

import jsonpath from 'jsonpath';


export class ObjectUtil{



public static FindObject(object: Object, pathIn: string) {
          
    return jsonpath.query(object,pathIn);
}


public static FindObjectAny(object: Object, pathIn: string){

    let ob = object;
    if ( pathIn!= null && ob !=null){
      pathIn.split(".").forEach(key=>{
        try{
          ob = ob[key];
        }catch(Exception){
          
        }
        
      })
    }
    
    return ob;
}


public static isNotEmpty(object:any):boolean{
    
    if ( object == null || object == undefined || object == "" ){
      return false;
    }else{
      if ( object instanceof Array){
        if (object.length == 0){
          return false;
        }
      }
      if ( object instanceof Boolean) {
        return true;
      }
      if ( object instanceof Object) {
        if ( Object.keys(object).length == 0){
          return false;
        }else{
          return true;
        }
      }else{
        return true;
      }
      
    }


}


public static isNumber(value){
    var reg = new RegExp('^[0-9]+$');
    return reg.test(value);
}

public static transformConditionToString(data:Object):string{
  
  let newData:string = "";
  let i:number = 0;
  for ( let key of Object.keys(data)){
      if ( data[key] == null ){
        if ( i > 0 ){
          newData = newData  +  ` and ${key} is null `;     
        }else{
          newData = newData  +  ` ${key} is null `;     
        }
      }else{
        if ( this.isNumber(data[key] as string ) && !String(data[key]).startsWith('0') ){
          if ( i > 0 ){
            newData = newData  +  ` and ${key} =  ${data[key]} `;
          }else{
            newData = newData  +  ` ${key} =  ${data[key]} `;
          }
        }else{
          if ( i > 0 ){
            newData = newData  +  ` and ${key} =  '${data[key]}' `;
          }else{
            newData = newData  +  ` ${key} =  '${data[key]}' `;
          }
        }
      }
      
      i++;
  }
  
  newData = newData.toLowerCase();
  return newData;
}

public static trasnformToString(data:Object):string{
    
    let newData:string = "";
    let i:number = 0;
    for ( let key of Object.keys(data)){
       
      if ( data[key] == null ){
        newData = newData  +  ` and ${key} is null `;     
      }else{
      /*if ( i > 0 ){
          newData = newData  +  ` and ${key} =  ${data[key]} `;
        }else{
          newData = newData  +  ` ${key} =  ${data[key]} `;
        }
        i++;*/
        if ( this.isNumber(data[key] as string )){
          newData = newData  +  ` ${key} =  ${data[key]} `;
        }else{
          newData = newData  +  ` ${key} =  '${data[key]}' `;
        }
      }
    }

    newData = newData.toLowerCase();
    return newData;
  }


public static arrayStringToString(data:string[]):string{

    let newData:string = "";
    let i = 0;
    data.forEach((value:any)=>{
        if ( i > 0 ){
          newData = newData  +  ` ${value} `;
        }else{
          newData = newData  +  ` ${value} `;
        }
        i++;
        
    });

    newData = newData.toLowerCase();
    return newData;
  }

  public static extracJson(file:string){

    var jsons:string[] = []
    var temp:string = "";
    var i = 0;
    var l = 0;
    var r = 0;
    var insideVariable = false;
    var insideJson = false;
    for(var z = 0; z<file.length; z++ ) {
      var eachChar = file.charAt(z);
      var nextChar = eachChar;
      
      if ( i + 1 < file.length ){
        nextChar = file.charAt(i+1);
      }
      
      if ( eachChar == '{' && nextChar != '@' ) {
        
        if ( insideJson ){
          temp +=eachChar;
        }else{
          temp = eachChar;
          insideJson = true;
        }
        l++;
        
      }else{
        if ( eachChar == '{' && nextChar == '@' ) {
          insideVariable = true;
        }
        
        if ( eachChar == '}' && insideVariable){
          insideVariable = false;
        }else{
        
          if ( eachChar == '}' && !insideVariable){
            temp +=eachChar;
            r++;
          }else{
            temp +=eachChar;
          }
        }
      }
      
      if( l == r && insideJson && !insideVariable){
        
        jsons.push(temp);
        insideJson = false;
        temp="";
        l = 0;
        r = 0;
      }
      
      i++;
    }
    
    return jsons
  }

  public static stringify(obj) {
    let cache = [];
    let str = JSON.stringify(obj, function(key, value) {
      if (typeof value === "object" && value !== null) {
        if (cache.indexOf(value) !== -1) {
          // Circular reference found, discard key
          return;
        }
        // Store value in our collection
        cache.push(value);
      }
      return value;
    });
    cache = null; // reset the cache
    return str;
  }

  public static dummyWait(timer:number, showLog:boolean = false):Promise<boolean>{
    return new Promise((resolve) => {
          
          setTimeout(() => {
              if ( showLog ){
                console.log("Waited for " + timer + " seconds.");
              }
              resolve(true);
          }, timer); 
      });
  }

  public static getEnumKeyByValue<T extends Record<string, string | number>>(
    enumObj: T,
    value: T[keyof T]
    ): keyof T | undefined {
      return Object.keys(enumObj).find(key => enumObj[key] === value) as keyof T;
  }

  
  private static isObject(item: any): item is Record<string, any> {
    return item && typeof item === 'object' && !Array.isArray(item);
  }

  public static deepMerge<T>(target: any, source: Partial<T>): T {
    const output = { ...target };

    for (const key in source) {
      if (this.isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = ObjectUtil.deepMerge((target as any)[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    }

    return output;
  }


  public static deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }


  public static objectToDotPaths(obj:any, prefix = '') {
    const paths = [];

    for (const key in obj) {
      const path = prefix ? `${prefix}.${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        paths.push(...this.objectToDotPaths(obj[key], path));
      } else {
        paths.push({ path:prefix, value: obj});
      }
    }

    return paths;
  }




}


